import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KeepalivePageRoutingModule } from './keepalive-routing.module';
import { KeepalivePageComponent } from './pages/keepalive/keepalive.page';
import { DataModule } from './components/data/data.module';
import { ToolsModule } from '../tools/tools.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { MatGridListModule } from '@angular/material/grid-list';

@NgModule({
  imports: [CommonModule, FormsModule, KeepalivePageRoutingModule, DataModule, ToolsModule, MaterialModule, MatGridListModule],
  declarations: [KeepalivePageComponent],
  providers: [],
  exports: [ToolsModule],
})
export class KeepalivePageModule {}
